import { OnInit, Component, ElementRef, ViewChild, Input, Output, } from '@angular/core';
import { Subject } from "rxjs";

@Component({
  selector: 'app-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss']
})
export class AudioComponent implements OnInit {

  @ViewChild('audio') audio: ElementRef;
  @Input("playAudio") playAudio: Subject<any>;

  invalidScan = '../../../assets/sounds/beep-1.mp3';
  invalidScanFlag: boolean = false;
  trouble = '../../../assets/sounds/beep-3.mp3';
  troubleFlag: boolean = false;
  notice = '../../../assets/sounds/beep-6.mp3';
  noticeFlag: boolean = false;
  piglet = '../../../assets/sounds/piglet.wav';
  pigletFlag: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.playAudio.subscribe((sound) => {
      switch(sound) {
        case 'invalidScan':
              this.invalidScanFlag = true;
              this.troubleFlag = false;
              this.noticeFlag = false;
              this.pigletFlag = false;
              this.play();
              break;
        case 'trouble':
              this.troubleFlag = true;
              this.invalidScanFlag = false;
              this.noticeFlag = false;
              this.pigletFlag = false;
              this.play();
              break;                  
        case 'notice':
              this.noticeFlag = true;
              this.invalidScanFlag = false;
              this.troubleFlag = false;
              this.pigletFlag = false;
              this.play();
              break;
        case 'piglet':
              this.pigletFlag = true;
              this.invalidScanFlag = false;
              this.troubleFlag = false;
              this.noticeFlag = false;
              this.play();
              break;
      }
    });
  }

  play(): void {
    const audio = this.audio.nativeElement;
    if (audio.paused || audio.ended) {
      audio.play()
      .catch((error: any) => {
        console.error('Failed to play audio:', error);
      });
      
    }
  }
}